import { RootState } from "../../index";
import { UserRole } from "../../../types/users";

export const selectAuth = (state: RootState) => state.auth;

export const selectIsAuthenticated = (state: RootState) =>
  state.auth.isAuthenticated;

export const selectRoles = (state: RootState) =>
  state.auth.roles;

export const selectAuthUser = (state: RootState) => state.auth.user;

export const selectUserProfile = (state: RootState) => state.auth.profile;

export const selectHasRole =
  (role: UserRole) => (state: RootState) =>
    state.auth.roles.includes(role);

// Pending verification selectors
export const selectPendingVerification = (state: RootState) =>
  state.auth.pendingVerification;

export const selectPendingEmail = (state: RootState) =>
  state.auth.pendingVerification?.email ?? null;

export const selectPendingAppUserUuid = (state: RootState) =>
  state.auth.pendingVerification?.appUserUuid ?? null;

export const selectPendingOrgUuid = (state: RootState) =>
  state.auth.pendingVerification?.orgUuid ?? null;

export const selectShowWelcome = (state: RootState) => state.auth.showWelcome;